import _ from "lodash";
import store from "CommonState/store";
import {
  Component,
} from "react";
import {
  Alert,
  Button,
  FormControl,
  ProgressBar,
} from "react-bootstrap";
import {
  Awesome,
  Tooltip,
} from "CommonComponents/bricks";
import Upload from "rc-upload";
import {
  getApiHeaders,
} from "CommonCore/apifetch";
import {
  renderChildren,
} from "CommonCore/router-util";

class DownloadButton extends Component {
  render() {
    return <Tooltip overlay={this.props.tooltip || "Anlage herunterladen"}><Button variant='outline-primary' onClick={this.handleDownload}><Awesome name='download' /></Button></Tooltip>;
  }
  handleDownload = () => {
    const { token, urldownload } = this.props;
    window.open(`/api/${ urldownload }?token=${ token }`);
  };
}

const MAX_UPLOAD_SIZE = 200 * 1024 * 1024; // 200 MB

class UploadButton extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { urlupload, urldownload, accept, params, token, filename } = this.props;
    const { progress, errorMessage, dokid, selectedFileName } = this.state;
    const content = <>
      {(urldownload || dokid) && <span><DownloadButton
        token={token}
        urldownload={urldownload || `shkantrag/dokument/download/${ dokid }`}
        name={selectedFileName || filename}
      />{"\u00a0  "}</span>}
      <Upload
        action={`/api/${ urlupload }`}
        headers={getApiHeaders()}
        beforeUpload={this.beforeUpload}
        onStart={this.onStart}
        onProgress={this.onProgress}
        onSuccess={this.onSuccess}
        accept={accept}
        data={_.mapValues(params, v => _.isNil(v) ? "" : v)}
        onError={this.onError}
      >
        {!_.isNumber(progress) && <a style={{ textDecoration: "none" }}>
          <span>
            <Awesome name='upload' />{"\u00a0  "}
            <span style={{ textDecoration: "underline" }}>Hochladen</span></span></a>}
      </Upload>
      {_.isNumber(progress) && <ProgressBar now={progress} />},
      {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
    </>;

    return <div>{content}{renderChildren(this.props)}</div>;
  }

  beforeUpload = file => {
    if (file.size > MAX_UPLOAD_SIZE) {
      this.setState({
        errorMessage: "Dokument zu groß, maximal 200 MB erlaubt",
        progress: undefined,
        selectedFileName: undefined,
      });
      return false;
    }
    return true;
  };

  onError = (err, body) => {
    this.setState({
      errorMessage: (body && body.um) || err.message,
      progress: undefined,
      selectedFileName: undefined,
    });
  };

  onStart = file => {
    this.setState({
      progress: 0,
      errorMessage: undefined,
      selectedFileName: file.name,
    });
  };

  onProgress = ({ percent }) => {
    this.setState({ progress: percent });
  };

  onSuccess = response => {
    this.setState({
      progress: undefined,
      dokid: response.data[0].dok_id,
    });
    this.props.afterUpload && this.props.afterUpload();
  };
}

@store("user")
export default class DokumentWidget extends Component {
  // Widget zur Anzeige von Dokumentinformationen in einer Liste inkl. Upload/Download
  constructor() {
    super();
    this.state = { added: false };
  }
  render() {
    const { user, urlupload, urldownload, urlemptytext, name, params, filename, readonly, requireName } = this.props;

    if (requireName && !this.state.added) {
      return <tr><td colSpan='2'>
        <Button variant='outline-primary' block onClick={() => this.setState({ added: true })}>
          <Awesome name='plus' />&nbsp;Anlage hinzufügen
        </Button>
      </td></tr>;
    }
    return <tr>
      <td>
        {requireName && <FormControl
          name='dok_name' autoFocus
          placeholder='Bitte vergeben Sie einen Namen für die Anlage' value={this.state.dok_name}
          onChange={evt => this.setState({ dok_name: evt.target.value })} />}
        {!requireName && this.props.downloadProminent ? <strong>{name}</strong> : name}

      </td>
      <td className='td-aktionen'>

        {!_.isEmpty(urldownload) && (_.isEmpty(urlupload) || readonly) &&
            <DownloadButton tooltip={this.props.downloadTooltip} prominent={this.props.downloadProminent} token={user.token} name={filename} urldownload={urldownload} />}

        {!_.isEmpty(urlupload) && !readonly && !(requireName && !this.state.dok_name) && <UploadButton
          token={user.token}
          urlupload={urlupload}
          filename={filename}
          urldownload={urldownload}
          params={requireName ? _.assign(params, { dok_name: this.state.dok_name }) : params}
          accept='.pdf'
          requireName={requireName}
          afterUpload={this.props.afterUpload}
        >
          {requireName && this.state.added && <span><Button variant='outline-primary' style={{ marginLeft: "1em" }} onClick={() => this.setState({ added: false, dok_name: null })}>Abbrechen</Button></span>}
        </UploadButton>}

        {!_.isEmpty(urlupload) && !readonly && (requireName && !this.state.dok_name) &&
            <span><Button variant='outline-primary' style={{ marginLeft: "1em" }} onClick={() => this.setState({ added: false, dok_name: null })}>Abbrechen</Button></span>}


        {_.isEmpty(urlupload) && _.isEmpty(urldownload) && urlemptytext}
      </td>
    </tr>;
  }
}
